import { StockVisual } from '../../components/StockVisual';
import { OrderMatrix } from '../../components/OrderMatrix';
import { OrderMatrixSkeleton } from "../../components/OrderMatrixSkeleton";
import { Modal } from 'bootstrap';

class ItemIndex {
    init() {
        const stockVisual = new StockVisual();
        let   ribbons = document.querySelectorAll('.products-viewer');

        if (useGtmEcommerceEvents) {
            if (ribbons) {
                ribbons.forEach(ribbon => {
                    let ribbonSource = ribbon.querySelector('.titlebar h2') ? ribbon.querySelector('.titlebar h2').innerText : '';
                    let ribbonElements = ribbon.querySelectorAll('.pv-product') ? ribbon.querySelectorAll('.pv-product') : '';

                    if (ribbonElements) {
                        ribbonElements.forEach(ribbonElement => {
                            ribbonElement.addEventListener('click', Event => {
                                document.dispatchEvent(new CustomEvent('GTMSelectItem',  {
                                    detail: {
                                        itemElement: ribbonElement,
                                        itemId: ribbonElement.dataset.modelNo,
                                        itemName: ribbonElement.dataset.description,
                                        itemPrice: atob(ribbonElement.dataset.price),
                                        itemListId: ribbonSource,
                                        itemListName: ribbonSource
                                    }
                                }));
                            });
                        });
                    }
                });
            }
        }

        stockVisual.init();

        // Closest Variant
        const { showModal, color, variant } = document.querySelector('#closestVariantDataContainer').dataset;

        if (showModal && color && variant) {
            const modal = new Modal(document.querySelector('#closestVariantModal'));

            modal.show();
        }
    }
}

addEventListener('DOMContentLoaded', e => {
    const itemIndex = new ItemIndex();
    const orderMatrixSkeleton = new OrderMatrixSkeleton();

    itemIndex.init();
    orderMatrixSkeleton.init();
});

document.addEventListener('readystatechange', e => {
    if (e.target.readyState === 'complete') {
        const orderMatrix = new OrderMatrix();

        orderMatrix.init();
    }
});
